import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ServiceLogGuard } from './services/service-log.guard';
import { ServiceLogComponent } from './service-log.component';
import { ServiceLogListComponent } from './service-log-list/service-log-list.component';
import { ServiceLogDetailComponent } from './service-log-detail/service-log-detail.component';
import { oktaIdmCanActivate } from '../shared/oktaIdmCanActivate';

export function onAuthRequired({ oktaAuth, router }) {
  // Redirect the user to your custom login page
  router.navigate(['/login']);
}

const routes: Routes = [
  {
    path: 'servicelogs',
    component: ServiceLogComponent,
    canActivate: [oktaIdmCanActivate,ServiceLogGuard],
    data: {
      onAuthRequired
    },
    children: [
      {
        path: '',
        component: ServiceLogListComponent,
      }
    ]
  },
  {
    path: 'servicelog',
    component: ServiceLogComponent,
    children: [
      {
        path: ':id',
        component: ServiceLogDetailComponent,
        canActivate: [oktaIdmCanActivate, ServiceLogGuard],
        data: {
          onAuthRequired
        }
      },
      { path: '', redirectTo: 'servicelogs', pathMatch: 'full' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ServiceLogRoutingModule { }
